import { Component, OnInit } from '@angular/core';
import { AwardService } from '../../../../core/services/awards/awards.service';
import { NavigationEnd, Router } from '@angular/router';
import { OwlOptions } from 'ngx-owl-carousel-o';
declare const bootstrap: any;
@Component({
    selector: 'app-awards',
    templateUrl: './awards.component.html',
    styleUrls: ['./awards.component.scss']
})
export class AwardsComponent implements OnInit {
    awardsList: any=[];
    isSideBarOpen:boolean=false;
    version: any = [];
    allVersions: any = [];
    isArchive:boolean=false;
    isArchivePage:boolean=false;
    descriptionDetails: any;
    customOptions: OwlOptions = {
        loop: false,
        mouseDrag: true,
        touchDrag: true,
        autoWidth: true,
        pullDrag: true,
        dots: true,
        merge: false,
        navSpeed: 700,
        responsive: {
          0: {
            items: 1
          },
          400: {
            items: 1
          },
          500:{
            items: 2
          },
          940: {
            items: 3
          },
          1200:{
            items: 4
          },

          1800: {
            items: 6
          }
        }
      }
    constructor(public awardService: AwardService, private router: Router) { }

    ngOnInit(): void {
        if(this.router.url.includes('/archive')){
            this.isArchive = true;
        }
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                window.scrollTo(0, 0); // Scroll to the top
            }
        });
        this.getAllVersion()
        if(this.isArchive) this.onChangeVersion;
        else{    
            this.awardService.getAwardsHome().subscribe((res) => {
            this.awardsList = res;
            console.log(this.awardsList, 'Award list');
            this.awardsList.awardsBanner.push({
                "id": 9,
                "category": "jury112312",
                "award": "CINEJOY JURY",
                "award_message1": "Meet the luminaries judging the awards!",
                "award_message2": "test1",
                "thumbnail": "../../../../../assets/images/behind-the-scenes.jpg",
                "mobile_thumbnail": "../../../../../assets/images/behind-the-scenes.jpg",
                "movie_link": this.isArchive ? "/cinejoy/archive/jury" :"/cinejoy/jury",
                "award_version": "1",
                "type": "Jury"
            })
            this.awardsList.awardsBanner.forEach((element, index) => {
                if (this.isTextLong(element.award_message1)) {
                    this.awardsList.awardsBanner[index].isShowReadMoreBanner = true;
                }
            });
            this.awardsList.recentWinners.forEach((element, index) => {
                if (this.isTextLong(element.award)) {
                    this.awardsList.recentWinners[index].isShowReadMorewinner = true;
                }
            });
        }, err => {

        })}
    }

    onToggleSideNav(){
        this.isSideBarOpen = !this.isSideBarOpen;
    }

    navigateAllAwards(){
        if(this.isArchive){
            this.router.navigate(['/cinejoy/archive/all-awards'])

        }else{
            this.router.navigate(['/cinejoy/all-awards'])
        }
    }

    goToLink(url: string, type?:any){
        if(type === 'Jury'){
            this.router.navigate([url])
        }else{
            if (/(http(s?)):\/\//i.test(url)) {
                window.open(url, "_blank");
            } else {
                window.open(`https://${url}`);
            }
        }

    }

    getAllVersion() {
        this.awardService.getAllAwardsVersion().subscribe(data => {
            //Checking if current page is Archive, don't show Current version else show Current version.
            if (this.isArchive) {
                const archiveVersions = data.awardsVersions.filter(v => v.isCurrent === 0);
                this.allVersions = archiveVersions;
                const maxVersion = archiveVersions.reduce((prev, current) =>
                    Number(prev.awardsVersion) > Number(current.awardsVersion) ? prev : current
                ); //Setting the version to the biggest number
                //Checking for any pre-set data
                if(this.awardService.getVersion()) this.version = this.awardService.getVersion().id;
                else this.version = maxVersion?.id;
                // this.version = maxVersion?.id;
                this.onChangeVersion(this.version);
              } else {
                this.allVersions = data.awardsVersions;
                const currentVersion = this.allVersions.find(v => v.isCurrent === 1);
                this.version = currentVersion?.id;
              }
        }, err => {

        })
    }

    onChangeVersion(event: any) {
        let version = this.allVersions.find((v: any) => ( parseInt(v.id) === parseInt(this.version)));
        this.awardService.setVersion(version);
        this.awardService.getArchivedHomePageByVersion(version.awardsVersion).subscribe((res) => {
            this.awardsList = res;
            this.awardsList.awardsBanner.push({
                "id": 9,
                "category": "jury112312",
                "award": "CINEJOY JURY",
                "award_message1": "Meet the luminaries judging the awards!",
                "award_message2": "test1",
                "thumbnail": "../../../../../assets/images/behind-the-scenes.jpg",
                "mobile_thumbnail": "../../../../../assets/images/behind-the-scenes.jpg",
                "movie_link": this.isArchive ? "/cinejoy/archive/jury" : "/cinejoy/jury",
                "award_version": "1",
                "type": "Jury"
            })
            this.awardsList.awardsBanner.forEach((element, index) => {
                if (this.isTextLong(element.award_message1)) {
                    this.awardsList.awardsBanner[index].isShowReadMoreBanner = true;
                }
            });
            this.awardsList.recentWinners.forEach((element, index) => {
                if (this.isTextLong(element.award)) {
                    this.awardsList.recentWinners[index].isShowReadMorewinner = true;
                }
            });
        }, err => {

        })
    }

    onClickOfDescription(event: Event, item: any) {
        event.stopPropagation()
        this.descriptionDetails = item;
        const modalElement = document.getElementById('movieDescription');
        const bootstrapModal = new bootstrap.Modal(modalElement);
        bootstrapModal.show();
    }

    getTruncatedText(text: string): string {
        return text.length > 40 ? text.substring(0, 40) + '...' : text;
    }

    isTextLong(text: string): boolean {
        return text.length > 40;
    }
}